import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "./index.css";
import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { forwardRef as a } from "react";
import { Container as t } from "@design-system/container";
import { ExtendableImage as i } from "@design-system/extendable-image";
import { Section as c } from "@design-system/section";
import { Typography as r } from "@design-system/typography";
import n from "classnames";
import { CtaBlock as l } from "@design-system/cta-block";
import { HeadingBlock as d } from "@design-system/heading-block";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function m(e, s) {
  var a = {};
  for (var t in e) {
    Object.prototype.hasOwnProperty.call(e, t) && s.indexOf(t) < 0 && (a[t] = e[t]);
  }
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;
    for (t = Object.getOwnPropertySymbols(e); i < t.length; i++) {
      s.indexOf(t[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[i]) && (a[t[i]] = e[t[i]]);
    }
  }
  return a;
}
var g = function g(_ref) {
    var s = _ref.props,
      _ref$component = _ref.component,
      a = _ref$component === void 0 ? l : _ref$component,
      t = _ref.className;
    return e(a, Object.assign({
      className: t
    }, s));
  },
  o = function o(_ref2) {
    var s = _ref2.props,
      _ref2$component = _ref2.component,
      a = _ref2$component === void 0 ? d : _ref2$component,
      t = _ref2.className;
    return e(a, Object.assign({
      className: t
    }, s));
  },
  p = a(function (a, l) {
    var _n;
    var d = a.className,
      p = a.variant,
      b = a.tag,
      u = a.mode,
      f = a.disclaimer,
      _ = a.backgroundImage,
      h = a.foregroundImage,
      O = a.headingBlock,
      j = a.ctaBlock,
      _a$size = a.size,
      N = _a$size === void 0 ? "hero" : _a$size,
      _a$width = a.width,
      v = _a$width === void 0 ? "full-screen" : _a$width,
      y = a.uid,
      x = m(a, ["className", "variant", "tag", "mode", "disclaimer", "backgroundImage", "foregroundImage", "headingBlock", "ctaBlock", "size", "width", "uid"]);
    return s(c, Object.assign({
      ref: l,
      className: n("cds-teaser-full-image", d, "cds-teaser-full-image--".concat(N, "-size"), "cds-teaser-full-image--".concat(v, "-width"), "cds-teaser-full-image--".concat(N, "-").concat(v), (_n = {}, _defineProperty(_n, "cds-teaser-full-image--".concat(p, "-variant"), p), _defineProperty(_n, "cds-teaser-full-image--has-image", h), _n)),
      element: b,
      "data-component-uid": y
    }, x, {
      children: [e(t, Object.assign({
        maxWidth: "max-text",
        className: "cds-teaser-full-image__container"
      }, {
        children: s(c, Object.assign({
          mode: u,
          removeAllSpacing: !0,
          className: n("cds-teaser-full-image__section")
        }, {
          children: [s("div", Object.assign({
            className: "cds-teaser-full-image__text"
          }, {
            children: [s("div", Object.assign({
              className: "cds-teaser-full-image__text-content"
            }, {
              children: [O && e(o, Object.assign({
                className: "cds-teaser-full-image__heading"
              }, O)), j && e(g, Object.assign({
                className: "cds-teaser-full-image__cta"
              }, j))]
            })), f && e(r, {
              className: "cds-teaser-full-image__disclaimer",
              variant: "body",
              size: "s",
              content: f
            })]
          })), h && e("div", Object.assign({
            className: "cds-teaser-full-image__fg"
          }, {
            children: e(i, Object.assign({}, h, {
              className: "cds-teaser-full-image__fg-img"
            }))
          }))]
        }))
      })), _ && e("div", Object.assign({
        className: "cds-teaser-full-image__bg"
      }, {
        children: e(i, Object.assign({
          className: "cds-teaser-full-image__bg-img"
        }, _))
      }))]
    }));
  }),
  b = a(function (a, t) {
    var l = a.className,
      d = a.tag,
      p = a.mode,
      b = a.backgroundImage,
      u = a.foregroundImage,
      f = a.headingBlock,
      _ = a.disclaimer,
      h = a.ctaBlock,
      O = a.variant,
      _a$size2 = a.size,
      j = _a$size2 === void 0 ? "hero" : _a$size2,
      _a$width2 = a.width,
      N = _a$width2 === void 0 ? "full-screen" : _a$width2,
      v = a.uid,
      y = m(a, ["className", "tag", "mode", "backgroundImage", "foregroundImage", "headingBlock", "disclaimer", "ctaBlock", "variant", "size", "width", "uid"]);
    return s(c, Object.assign({
      ref: t,
      className: n("cds-teaser-split", l, "cds-teaser-split--".concat(j, "-size"), "cds-teaser-split--".concat(N, "-width"), "cds-teaser-split--".concat(j, "-").concat(N), _defineProperty({}, "cds-teaser-split--".concat(O, "-variant"), O)),
      removeAllSpacing: !0,
      mode: p,
      element: d,
      "data-component-uid": v
    }, y, {
      children: [s("div", Object.assign({
        className: "cds-teaser-split__text"
      }, {
        children: [s("div", Object.assign({
          className: "cds-teaser-split__text-content"
        }, {
          children: [f && e(o, Object.assign({
            className: "cds-teaser-split__heading"
          }, f)), h && e(g, Object.assign({
            className: "cds-teaser-split__cta"
          }, h))]
        })), _ && e(r, {
          className: "cds-teaser-split__disclaimer",
          variant: "body",
          size: "s",
          content: _
        })]
      })), s("div", Object.assign({
        className: "cds-teaser-split__image"
      }, {
        children: [b && e(i, Object.assign({
          className: "cds-teaser-split__bg-img"
        }, b)), u && e("div", Object.assign({
          className: "cds-teaser-split__image-overlay"
        }, {
          children: e(i, Object.assign({}, u, {
            className: "cds-teaser-split__fg-img"
          }))
        }))]
      }))]
    }));
  }),
  u = function u(e, s, a, t, i) {
    var _n3;
    return n(e, t, (_n3 = {}, _defineProperty(_n3, "cds-strip--".concat(s, "-variant"), s), _defineProperty(_n3, "cds-strip--".concat(a, "-width"), a), _defineProperty(_n3, "cds-strip--has-image", i), _n3));
  },
  f = function f(e) {
    return "strip-center" === e ? "center" : "start";
  },
  _ = function _(e, s) {
    var a = Object.assign(Object.assign({}, e.props), {
      align: f(s)
    });
    return Object.assign(Object.assign({}, e), {
      props: a
    });
  },
  h = a(function (a, n) {
    var l,
      d = a.className,
      p = a.variant,
      b = a.tag,
      h = a.mode,
      _a$width3 = a.width,
      O = _a$width3 === void 0 ? "full-screen" : _a$width3,
      j = a.foregroundImage,
      N = a.headingBlock,
      v = a.disclaimer,
      y = a.ctaBlock,
      x = a.uid,
      k = m(a, ["className", "variant", "tag", "mode", "width", "foregroundImage", "headingBlock", "disclaimer", "ctaBlock", "uid"]);
    return e(c, Object.assign({
      ref: n,
      className: u("cds-strip", p, O, d, j),
      mode: h,
      element: b,
      "data-component-uid": x
    }, k, {
      children: s(t, Object.assign({
        className: "cds-strip__container",
        maxWidth: (l = j, l ? "max-grid" : "max-text")
      }, {
        children: [s("div", Object.assign({
          className: "cds-strip__text"
        }, {
          children: [N && e(o, Object.assign({
            className: "cds-strip__heading"
          }, _(N, p))), y && e(g, Object.assign({
            className: "cds-strip__cta"
          }, _(y, p))), v && e(r, {
            className: "cds-strip__disclaimer",
            variant: "body",
            size: "xs",
            content: v,
            align: f(p)
          })]
        })), j && e("div", Object.assign({
          className: "cds-strip__image"
        }, {
          children: e(i, Object.assign({
            className: "cds-strip__image-img"
          }, j))
        }))]
      }))
    }));
  }),
  O = a(function (s, a) {
    var t = s.variant,
      i = m(s, ["variant"]);
    switch (t) {
      case "split-start":
      case "split-end":
        return e(b, Object.assign({
          ref: a,
          variant: t
        }, i));
      case "strip-start":
      case "strip-center":
        return e(h, Object.assign({
          ref: a,
          variant: t
        }, i));
      case "full-image":
        return e(p, Object.assign({
          ref: a,
          variant: t
        }, i));
      default:
        return null;
    }
  });
export { O as Teaser };